// Auto-generated from server/src/Jobs.Domain/Constants/ProjectStatusConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const ProjectStatusConstants = {
  Active: 'c1d2e3f4-0004-4000-8000-000000000001',
  Cancelled: 'c1d2e3f4-0004-4000-8000-000000000002',
  Descoped: 'c1d2e3f4-0004-4000-8000-000000000003',
  Completed: 'c1d2e3f4-0004-4000-8000-000000000004'
} as const;
